import React, { Component } from 'react';
import './Description.css';
import Utils from '../../../base/Utils';

class Description extends Component {
    availableAligns = ['Left', 'Center', 'Right'];
    availableColors = ['Dark', 'Light'];
    availableWeights = ['Normal', 'Bold'];
    
    render() {
        var text = this.props.text;
        var customColor = this.props.customColor;
        var align = Utils.checkAvailability(this.availableAligns, this.props.align);
        var color = Utils.checkAvailability(this.availableColors, this.props.color, true);
        var weight = Utils.checkAvailability(this.availableWeights, this.props.weight);
        
        var classValue = "Description " + align + " " + color + " " + weight;
        
        if(Utils.checkArray(text)) {
            text = text.map((value) => {
                return <p>{value}</p>;
            });
        }
        
        var html = <div style={{color: customColor}} className={classValue}>
        {text}
        </div>;
        
        return html;
    }
}

export default Description;
